export class Remito {
    public nroRemito: number;
    public details: Array<Details>;
    public observacions: Array<Observacion>;
    public prorrogases: Array<Prorrogas>;
    public origen: string;
    public ptoEmision: string | null;
    public tipoRto: string | null;
    public nroShipper: number | null;
    public clase: string | null;
    public codDealer: string | null;
    public fecGen: Date | null;
    public dunsDock: string | null;
    public shipTo: string | null;
    public shipFrom: string | null;
    public codTransp: string | null;
    public patenteTransp: string | null;
    public comentario: string | null;
    public totalCont: string | null;
    public pesoNetoCont: number | null;
    public taraCont: number | null;
    public pesoBrutoCont: number | null;
    public estadoRemito: string | null;
    public fecUltimaImp: Date | null;
    public secCompania: number | null;
    public fecVtoCai: Date | null;
    public nroCai: string | null;
    public fecCreacion: Date | null;
    public usrCreacion: string | null;
    public fecModif: Date | null;
    public usrModif: string | null;
    public fecAnulacion: Date | null;
    public motivoAnulacion: string | null;
    public nroTicket: string | null;
    public idSolicitante: string | null;
    public codAlmacen: string | null;
    public descAlmacen: string | null;
    public codMotivo: string | null;
    public descMotivo: string | null;
    public dock: string | null;
    public dockDesc: string | null;
    public fecSalida: Date | null;
    public fecARetornar: Date | null;
    public fecRetorno: Date | null;
    public docRetorno: string | null;
    public fechaEnvraf: Date | null;
    public nombreDealer: string | null;
    public dlCiudad: string | null;
    public nombreTransp: string | null;
    public nameSolicitante: string | null;
    public cancelarFecha: Date | null;
    public cancelarObservacion: string | null;
    public isChecked: boolean;
    public printed:boolean;
    public nroRemitoEnd: number;
    public fecDesde: Date | null;
    public fecHasta: Date | null;
    public fecGenStart: string | null;
    public fecGenEnd: string | null;
    public almacens: Array<string>;
    public selectedAlmacens: string;

    static transformRemito(data:any): Remito {
        let remito = new Remito();

        remito.nroRemito = data.nroRemito;
        // remito.details = data.details;
        // remito.observacions = data.observacions;
        remito.origen = data.origen;
        remito.ptoEmision = data.ptoEmision;
        remito.tipoRto = data.tipoRto;
        remito.nroShipper = data.nroShipper;
        remito.clase = data.clase;
        remito.codDealer = data.codDealer;
        remito.fecGen = data.fecGen;
        remito.dunsDock = data.dunsDock;
        remito.shipTo = data.shipTo;
        remito.shipFrom = data.shipFrom;
        remito.codTransp = data.codTransp;
        remito.patenteTransp = data.patenteTransp;
        remito.comentario = data.comentario;
        remito.totalCont = data.totalCont;
        remito.pesoNetoCont = data.pesoNetoCont;
        remito.taraCont = data.taraCont;
        remito.pesoBrutoCont = data.pesoBrutoCont;
        remito.estadoRemito = data.estadoRemito;
        remito.fecUltimaImp = data.fecUltimaImp;
        remito.secCompania = data.secCompania;
        remito.fecVtoCai = data.fecVtoCai;
        remito.nroCai = data.nroCai;
        remito.fecCreacion = data.fecCreacion;
        remito.usrCreacion = data.usrCreacion;
        remito.fecModif = data.fecModif;
        remito.usrModif = data.usrModif;
        remito.fecAnulacion = data.fecAnulacion;
        remito.motivoAnulacion = data.motivoAnulacion;
        remito.nroTicket = data.nroTicket;
        remito.idSolicitante = data.idSolicitante;
        remito.codAlmacen = data.codAlmacen;
        remito.codMotivo = data.codMotivo;
        remito.fecSalida = data.fecSalida;
        remito.fecARetornar = data.fecARetornar;
        remito.fecRetorno = data.fecRetorno;
        remito.docRetorno = data.docRetorno;
        remito.fechaEnvraf = data.fechaEnvraf;
        remito.cancelarFecha = data.cancelarFecha;
        remito.cancelarObservacion = data.cancelarObservacion;
        remito.isChecked =data.isChecked;
        remito.printed=data.printed;
        remito.nroRemitoEnd=data.nroRemitoEnd;
        return remito;
    }
}

export class Details {
    public id: number | undefined;
    public origen: string | undefined;
    public ptoEmision: string | null;
    public remito: Remito;
    public nroParte: string | undefined;
    public descParte: string | undefined;
    public cantidad: number | undefined;
    public unidadMedida: string | undefined;
    public unidadPeso: number | undefined;
    public pesoNeto: number | undefined;
    public nroParteCdk: string | undefined;
    public fecCreacion: Date | undefined;
    public usrCreacion: string | undefined;
    public fecModif: Date | undefined;
    public usrModif: string | undefined;
    public deleted: boolean;
}

export class Observacion {
    public id: number | undefined;
    public origen: string | undefined;
    public ptoEmision: string | null;
    public remito: Remito;
    public nroItemObs: number | undefined;
    public observacion: string | null;
    public fecCreacion: Date | undefined;
    public usrCreacion: string | undefined;
    public fecModif: Date | undefined;
    public usrModif: string | undefined;
}

export class Prorrogas {
  public id: number | undefined;
  public origen: string | undefined;
  public ptoEmision: string | null;
  public remito: Remito;
  public nroItemObs: number | undefined;
  public observacion: string | null;
  public fecCreacion: Date | undefined;
  public usrCreacion: string | undefined;
  public fecModif: Date | undefined;
  public usrModif: string | undefined;
  public fecProrrogas: Date | undefined;
}
